(function(angular){
	'use strict';
	
	var reitElementDiversificationMapObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		bindings: {
			reitElements: '<',
			centerOnFirstProperty: '<?'
		},
		controller: [
			'$filter',
			'$interpolate',
			'$scope', 
			'$templateRequest', 
			'$timeout', 
			'mapboxgl', 
			'MAPBOX_TOKEN', 
			'STATIC_BASE_PATH',
			ReitElementDiversificationMapFunction
		],
		controllerAs: 'reitElementDiversificationMap'
	};
	
	angular
		.module('reitElementListingModule')
		.component('reitElementDiversificationMap', reitElementDiversificationMapObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/reit-element-container/reit-element-diversification-map.html';
	}
	
	function ReitElementDiversificationMapFunction(
		$filter,
		$interpolate,
		$scope,
		$templateRequest,
		$timeout,
		mapboxgl,
		MAPBOX_TOKEN,
		STATIC_BASE_PATH) {
		
		var reitElementDiversificationMap = this;
		var geoJson = { 
			"type" : "Featured Assets", 
			"features" : [] 
		};
		var map;
		var mapLoaded = false;
		var markersCreated = false;
		var colorStops = [];

		reitElementDiversificationMap.$onInit = function() {
			reitElementDiversificationMap.showMap = mapboxgl.supported();
		};
		
		function initMap() {
			mapboxgl.accessToken = MAPBOX_TOKEN;
			if(angular.isUndefined(map)) {
				var centerLatLong;
				var initZoom;

				if (reitElementDiversificationMap.centerOnFirstProperty) {
					centerLatLong = [reitElementDiversificationMap.reitElements[0].lon, 
					reitElementDiversificationMap.reitElements[0].lat];
					initZoom = 9;
				} else {
					centerLatLong = [-98.716052, 39.0281178];
					initZoom = 3;
				}

				map = new mapboxgl.Map({
					container: "js-reitElement-diversification-map",
					style: "mapbox://styles/mapbox/light-v9",
					attributionControl: false,
					center: centerLatLong,
					interactive: false,
					zoom: initZoom
				});

				map.addControl(new mapboxgl.NavigationControl());
				map.dragPan.enable();
				map.doubleClickZoom.enable();
				map.on('load', function () {
					reitElementDiversificationMap.initMarkers();
					mapLoaded = true;
				});
			} else {
				if(mapLoaded) {
					reitElementDiversificationMap.initMarkers();
				}
			}

			$timeout(function() {
				map.resize();
			});
		}

		reitElementDiversificationMap.initMarkers = function() {
			reitElementDiversificationMap.createGeoJson();
			
			if (markersCreated){
				map.getSource('reitElements').setData(geoJson);
				map.removeLayer('clusters');
				map.removeLayer('cluster-count');
				map.removeLayer('unclustered-point');
			} else {
				map.addSource('reitElements', {
					type: 'geojson',
					data: geoJson,
					cluster: true,
					clusterMaxZoom: 10,
					clusterRadius: 25
				});
			}

			map.addLayer({
				id: 'clusters',
				type: 'circle',
				source: 'reitElements',
				filter: ['has', 'point_count'],
				paint: {
					'circle-color': '#878c92',
					'circle-radius': {
						property: 'point_count',
						type: 'interval',
						stops: [
							[3, 10],
							[4, 11],
							[5, 12],
							[6, 13],
							[7, 14]
						]
					},
					'circle-stroke-color': '#A1A6AC',
					'circle-stroke-opacity': 0.5,
					'circle-stroke-width': {
						property: 'point_count',
						type: 'identity'
					}
				}
			});

			map.addLayer({
				id: 'cluster-count',
				type: 'symbol',
				source: 'reitElements',
				filter: ['has', 'point_count'],
				layout: {
					'text-field': '{point_count_abbreviated}',
					'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
					'text-size': 12
				},
				paint: {
					'text-color': '#ffffff'
				}
			});

			map.addLayer({
				id: 'unclustered-point',
				type: 'circle',
				source: 'reitElements',
				filter: [
					'!has', 'point_count'
				],
				paint: {
					'circle-color': {
						'property': 'riskScore',
						'stops': getColorStopsArray()
					},
					'circle-radius': 6
				}
			});

			map.on('click', 'clusters', function(e){
				map.flyTo({
					center: [e.lngLat.lng, e.lngLat.lat],
					zoom: (map.style.z + 2)
				});
			});

			map.on('mouseenter', 'clusters', function () {
				map.getCanvas().style.cursor = 'pointer';
			});

			map.on('mouseleave', 'clusters', function () {
				map.getCanvas().style.cursor = '';
			});

			map.on('mouseenter', 'unclustered-point', function () {
				map.getCanvas().style.cursor = 'pointer';
			});

			map.on('mouseleave', 'unclustered-point', function () {
				map.getCanvas().style.cursor = '';
			});

			markersCreated = true;

			var templateUrl = STATIC_BASE_PATH + '/static/html/shared/charts/geographic-diversification-map/geographic-diversification-popup.html';

			$templateRequest(templateUrl).then(function (html) {

				map.on('click', 'unclustered-point', function (e) {
					var newScope = $scope.$new(true);					
					newScope.context = {
						imageUrl: e.features[0].properties.imageUrl,
						projectType: e.features[0].properties.projectType,
						city: e.features[0].properties.city,
						state: e.features[0].properties.state,
						color: e.features[0].properties.color,
						ratingLetter: e.features[0].properties.ratingLetter,
						subRating: e.features[0].properties.subRating
					};

					var template = $interpolate(html)(newScope);
					
					new mapboxgl.Popup({closeButton: false})
						.setLngLat(e.features[0].geometry.coordinates)
						.setHTML(template)
						.addTo(map);

					var elements = document.querySelectorAll('.js-redeemed-badge');

					angular.forEach(elements, function(element){
						element.style.display = e.features[0].properties.status === 'REDEEMED' ? 'block' : 'none';
					});
				});
			});
		};

		reitElementDiversificationMap.createGeoJson = function() {
			geoJson.features = [];
			angular.forEach(reitElementDiversificationMap.reitElements, function(reitElement) {
				if(reitElement.lat) {
					geoJson.features.push(reitElementDiversificationMap.createGeoJsonObject(reitElement));
				}
			});
		};
		
		function getColorStopsArray(){
			if(colorStops.length === 0) {
				for (var i=6; i<=20; i++){
					colorStops.push([i, $filter('riskColor')(i)]);
				}
			}
			
			return colorStops;
		}

		reitElementDiversificationMap.createGeoJsonObject = function(reitElement) {
			return {
				'type': 'asset',
				'properties': {
					'color': reitElement.rating.color,
					'description': reitElement.name,
					'city': reitElement.city,
					'state': reitElement.state,
					'imageUrl': reitElement.thumbnailUrl,
					'projectType': reitElement.projectType,
					'ratingLetter': reitElement.rating.letter,
					'subRating': reitElement.rating.sub,
					'riskScore': reitElement.riskScore,
					'status': reitElement.status
				},
				'geometry': {
					'type': 'point',
					'coordinates': [reitElement.lon, reitElement.lat]
				}
			};
		};

		$scope.$on('reitElementDiversificationMap:showMap', function(evt, reitElement) {
			if(reitElementDiversificationMap.showMap) {
				initMap();
			}
		});
	}
})(window.angular);